export default function comicNav(){
   if(
      document.getElementsByClassName("comic-nav").length == 0 ||
      typeof comicsData == "undefined"
   ){
      return;
   }

   const webtoon = document.getElementById("webtoon");
   const comicContainer = document.getElementById("cc-comic1-container");
   let comics = []; // All parsed comic data
   let comicData = {}; // This parsed comic data
   let currentSeason = null; // current season slug

   document.addEventListener("DOMContentLoaded", function(){
      parseComicsData();

      if(webtoon){
         if(comicData.webtoonId){
            webtoon.href = "https://www.webtoons.com/en/canvas/clawshot/list?title_no=" + comicData.webtoonId;
            webtoon.parentElement.style.display = "flex";
         }
      }

      if(comicContainer){
         comic1Stuff();
      }else{
         comic2Stuff();
      }
   });

   function parseComicsData(){
      let split1 = comicsData.split("|");
      for(let a = 0; a < split1.length; ++a){
         let split2 = split1[a].split(";");
         let newComic = {};
         newComic.tag = split2[0];
         newComic.webtoonId = split2[1];
         newComic.seasons = [];
         newComic.seasonlessChapters = [];
         let currentSeason = null;
         for(let b = 2; b < split2.length; ++b){
            if(split2[b][0] == "!"){
               newComic.seasons.push({
                  slug: split2[b].substring(1),
                  chapters: []
               });
               currentSeason = newComic.seasons[newComic.seasons.length - 1];
            }else{
               if(currentSeason){
                  currentSeason.chapters.push(split2[b]);
               }else{
                  newComic.seasonlessChapters.push(split2[b]);
               }
            }
         }

         comics.push(newComic);
      }

      for(let n = 0; n < comics.length; ++n){
         if(comics[n].tag.toLowerCase() == currentComicTag.toLowerCase()){
            comicData = comics[n];
            break;
         }
      }
   }

   // --------------------------------------------------------------------------
   function comic1Stuff(){
      const chapterSelect = document.getElementById("chapter-select");
      const pageSelect = document.getElementById("page-select");
      const prevPage = document.getElementById("comic1-prev");
      const nextPage = document.getElementById("comic1-next");
      const comicImages = comicContainer.getElementsByTagName("img");
      let currentChapter = null;
      let currentPageIndex = 0;
      let pageSelectOptions = [];

      // Get current chapter
      let split = window.location.pathname.split("/");
      for(let n = split.length; n --> 0;){
         if(split[n].length != 0){
            if(!currentChapter){
               currentChapter = split[n];
               break;
            }
         }
      }

      // Nav

      for(let n = 0; n < comicData.seasonlessChapters.length; ++n){
         let newOption = document.createElement("option");
         let chapter = comicData.seasonlessChapters[n];
         newOption._slug = chapter;
         newOption.text = tagTranslation[chapter] || chapter;
         chapterSelect.add(newOption);

         if(chapter == currentChapter){
            newOption.selected = true;
         }
      }

      for(let n = 0; n < comicImages.length; ++n){
         let newOption = document.createElement("option");
         newOption._index = n;
         newOption.text = (n + 1).toString();
         pageSelect.add(newOption);
         pageSelectOptions.push(newOption);
      }

      chapterSelect.addEventListener("change", function(){
         let chapterSlug = chapterSelect.options[chapterSelect.selectedIndex]._slug;
         let url = "/" + comicData.tag + "/" + chapterSlug + "/";
         window.location.href = url;
      });

      pageSelect.addEventListener("change", function(){
         let index = pageSelect.options[pageSelect.selectedIndex]._index;
         setPage(index);
      });

      // Page turning

      for(let n = 0; n < comicImages.length; ++n){
         comicImages[n].addEventListener("click", goNextPage);
      }
      prevPage.addEventListener("click", goPrevPage);
      nextPage.addEventListener("click", goNextPage);

      function goPrevPage(){
         let newIndex = currentPageIndex - 1;
         if(newIndex < 0){
            // go to previous chapter, maybe?
         }else{
            setPage(newIndex);
         }
      }
   
      function goNextPage(){
         let newIndex = currentPageIndex + 1;
         if(newIndex > comicImages.length - 1){
            // go to next chapter, maybe?
         }else{
            setPage(newIndex);
         }
      }

      // Don't let the browser load every image, just the current one (and cache the next one)
      function setPage(index){
         // lock container size
         comicContainer.style.minWidth = comicContainer.clientWidth + "px";
         comicContainer.style.minHeight = comicContainer.clientHeight + "px";

         comicImages[currentPageIndex].style.display = "none";

         let prevIndex = currentPageIndex;
         currentPageIndex = index;

         // Make the background the previous image, to prevent flickering
         comicImages[currentPageIndex].style.backgroundImage = (
            "url(" + comicImages[prevIndex].src + ")"
         );
         comicImages[currentPageIndex].style.backgroundSize = "100% 100%";

         // unlock container size on image load, also scroll to top
         let c = comicImages[currentPageIndex];
         comicImages[currentPageIndex].onload = function(){
            comicContainer.style.minWidth = "unset";
            comicContainer.style.minHeight = "unset";
            c.onload = null;

            document.getElementById("top").scrollIntoView();
         }

         comicImages[currentPageIndex].src = comicImages[currentPageIndex].dataset.src;
         comicImages[currentPageIndex].style.display = "block";

         // Make next page load quicker
         let nextIndex = index + 1;
         if(nextIndex < comicImages.length){
            comicImages[nextIndex].src = comicImages[nextIndex].dataset.src;
         }

         pageSelectOptions[index].selected = true;

         window.history.replaceState(null, "", window.location.pathname + "?page=" + (index + 1));
      }

      // Get current page from url
      if(window.location.search.length > 0){
         let pageNumber = parseInt(window.location.search.substring("?page=".length));
         if(!isNaN(pageNumber)){
            comicImages[0].style.display = "none";
            currentPageIndex = pageNumber - 1;
            if(currentPageIndex < 0) currentPageIndex = 0;
            if(currentPageIndex > comicImages.length - 1) currentPageIndex = comicImages.length - 1;
         }
      }
      setPage(currentPageIndex);
   }

   // --------------------------------------------------------------------------
   function comic2Stuff(){
      const seasonSelect = document.getElementById("season-select");
      const episodeSelect = document.getElementById("episode-select");
      let currentEpisode = null;

      // Get current episode and season slugs
      let split = window.location.pathname.split("/");
      for(let n = split.length; n --> 0;){
         if(split[n].length != 0){
            if(!currentEpisode){
               currentEpisode = split[n];
               continue;
            }
            if(!currentSeason) currentSeason = split[n];
         }
      }

      // Nav

      for(let n = 0; n < comicData.seasons.length; ++n){
         let newOption = document.createElement("option");
         let season = comicData.seasons[n];
         newOption._slug = season.slug;
         newOption.text = tagTranslation[season.slug] || season.slug;
         seasonSelect.add(newOption);

         if(season.slug == currentSeason){
            newOption.selected = true;

            for(let n = 0; n < season.chapters.length; ++n){
               let newOption = document.createElement("option");
               let episodeSlug = season.chapters[n];
               newOption._slug = episodeSlug;
               newOption.text = tagTranslation[episodeSlug] || episodeSlug;
               episodeSelect.add(newOption);

               if(episodeSlug == currentEpisode){
                  newOption.selected = true;
               }
            }
         }
      }

      seasonSelect.addEventListener("change", function(){
         let seasonSlug = seasonSelect.options[seasonSelect.selectedIndex]._slug;
         for(let n = 0; n < comicData.seasons.length; ++n){
            if(comicData.seasons[n].slug == seasonSlug){
               let firstEpisodeSlug = comicData.seasons[n].chapters[0];
               let url = "/" + comicData.tag + "/" + seasonSlug + "/" + firstEpisodeSlug + "/";
               window.location.href = url;

               break;
            }
         }
      });

      episodeSelect.addEventListener("change", function(){
         let seasonSlug = seasonSelect.options[seasonSelect.selectedIndex]._slug;
         let episodeSlug = episodeSelect.options[episodeSelect.selectedIndex]._slug
         let url = "/" + comicData.tag + "/" + seasonSlug + "/" + episodeSlug + "/";
         window.location.href = url;
      });
   }
}
